import React from 'react';
import {Button, Image} from 'semantic-ui-react';
import classNames from 'classnames';

import paths from '@paths';
import constants from '@constants';
import {Props} from './types';

import './index.scss';

const BeforeHeader: React.FC<Props> = props => {
  return (
    <div className="a__header-before">
      <div className="b__header-logo">
        <Button
          className="w__logo"
          onClick={() => props.history.push(paths.landing.main)}
        >
          <Image src={constants.IMAGES.LOGO_COLOR_H} />
        </Button>
      </div>
      <div className="w__header-buttons">
        <div
          className={classNames('b__signup-button', {
            active: props.location.pathname === paths.signUp.main,
          })}
        >
          <Button onClick={() => props.history.push(paths.signUp.main)}>
            <div className="b__inner">
              <span>新規登録</span>
              {props.location.pathname === paths.signUp.main && (
                <div className="divider" />
              )}
            </div>
          </Button>
        </div>
        <div
          className={classNames('b__signin-button', {
            active: props.location.pathname === paths.signIn.main,
          })}
        >
          <Button onClick={() => props.history.push(paths.signIn.main)}>
            <div className="b__inner">
              <span>ログイン</span>
              {props.location.pathname === paths.signIn.main && (
                <div className="divider" />
              )}
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BeforeHeader;
